import { createAuthClient } from "better-auth/react";
import type { AuthProvider } from "@pagemates/shared";

// Same origin in dev (Vite proxy) and prod (nginx), so no baseURL needed.
import { sessionToken } from "./api";
import { safeNext } from "./returnTo";
import { signIn } from "@pagemates/shared/copy";

const txt = signIn.providers;

export const authClient = createAuthClient({
  basePath: "/api/auth",
  fetchOptions: { auth: { type: "Bearer", token: () => sessionToken() ?? "" } },
});

export function signInWith(provider: AuthProvider, next = "/clubs") {
  return authClient.signIn.social({ provider, callbackURL: safeNext(next) });
}

/** @deprecated use signInWith("discord", next) */
export const signInWithDiscord = (next = "/clubs") => signInWith("discord", next);

export const PROVIDER_LABEL: Record<AuthProvider, string> = { discord: txt.discord, google: txt.google, apple: txt.apple };

/** Attach another provider to the signed-in account; comes back to Settings with ?linked=. */
export function linkProvider(provider: AuthProvider) {
  return authClient.linkSocial({ provider, callbackURL: `/me/settings?linked=${provider}` });
}
export function unlinkProvider(accountRowId: string) {
  return authClient.unlinkAccount({ accountId: accountRowId });
}

/** A brand-new account with nothing in it: probably someone who already has one under another provider. */
export function looksLikeWrongDoor(me: { clubs: unknown[]; accounts: AuthProvider[]; createdAt: string }) {
  return me.clubs.length === 0 && me.accounts.length <= 1 && Date.now() - new Date(me.createdAt).getTime() < 60 * 60_000;
}
